import { IMemberService, IMemberFilter } from "./member_service"
import { IMember } from '../schemas/entity_set'
import { IModelController, ModelController } from '../schemas/structure'
import { IAuthService } from '../authentication/auth_service'
import { MessageBox } from '../helpers/message_box';
import { AppServices, AngularServices, Routes } from '../helpers/config_keys'
import { ILookUpService } from '../settings/lookup_service';
let _: UnderscoreStatic = require("underscore")

class MemberCtrl extends ModelController<IMember> implements IModelController<IMember>  {
    lastFilter: IMemberFilter;
    genders = ["Male", "Female"]
    //lookUps = []

    static $inject = [AngularServices.State, AppServices.MemberService, AppServices.LookUpService];

    constructor(private $state: angular.ui.IStateService,
        private memberService: IMemberService,
        private lookupService: ILookUpService) {
        super("Member")
        this.start()
    }

    addNew() {
        this.formTitle = "New Member"
        this.newRecord = <IMember>{}
        this.setUpFormView()
    }

    open(id: number) { this.$state.go(Routes.MemberAccount, { id }) }

    pageChanged(page: number) {
        this.currentPage = page;
        this.lastFilter.pager.page = page;
        this.loading = true
        this.memberService.query(this.lastFilter).then((res) => {
            this.loading = false
            if (res.success) {
                this.records = res.data
                this.pageNumber = this.currentPage
            }
        })
    }

    fetch(filter: IMemberFilter) {
        filter.pager = filter.pager || { page: 1, size: 15 }
        this.lastFilter = angular.copy(filter)
        this.loading = true
        this.memberService.query(filter).then((res) => {
            this.loading = false
            if (res.success) {
                this.records = res.data
                this.totalRecords = res.total;
                this.totalPages = Math.ceil(res.total / this.recordSize);
                this.pageNumber = this.currentPage
            }
        })
    }

    saveRecord(member: IMember) {
        let theMember = angular.copy(member)
        this.saving = true
        this.memberService.save(theMember).then((res) => {
            this.saving = false
            if (res.success) {
                this.closeForm()
                this.fetch(this.lastFilter)
            }
        })
    }

    deleteRecord(member: IMember) {
        MessageBox.confirm("Delete Member", "Are you sure you want to delete record").then((yes) => {
            if (yes) {
                this.deleting = true
                this.memberService.delete(member.id).then((res) => {
                    this.deleting = false
                    if (res.success) {
                        this.closeForm()
                        this.fetch(this.lastFilter)
                    }
                })
            }
        })
    }

    private loadLookUps() {
        let self: any = this;
        // this.lookUps.forEach((lookup) => {
        //     this.lookupService.fetch(lookup).then((res) => {
        //         if (res.success) { self[lookup] = res.data }
        //     })
        // })
    }

    private start() {
        this.loadLookUps()
        this.fetch(<IMemberFilter>{})
    }

}

export { MemberCtrl }


// WEBPACK FOOTER //
// ./app/members/members_ctrl.ts